

import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Button from '@mui/material/Button';
import { Box, MenuItem, Modal, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { CrossIcon, Dropdown, SentIcon } from '../../svg';
import messageStyle from './messages.module.css';
import {saveCourse } from '../../MaterialUI';
import { addMessage ,createMessage} from '../redux/chat';
import { unwrapResult } from '@reduxjs/toolkit';




const NewMessageModal = ({ closeModal, open }) => {
    const admins = useSelector((state) => state.chat.admins);

    const dispatch = useDispatch()

    const schema = yup.object().shape({
        admin: yup.object().required('Admin is required'),
        name: yup.string().required('Message is required'),
    });

    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        resetForm,
        handleBlur,
        handleSubmit,
    } = useFormik({
        initialValues: {
            admin: '',
            name: '',
        },
        validationSchema: schema,
        onSubmit: async(values) => {
            // Response data
            const response = {
                recipientId: values.admin._id, // Assuming _id is the unique identifier for the admin
                message: values.name,
                type: 'TEXT', // Hardcoded type
            };
            
            const result=await  dispatch(createMessage(response))
        //  await   dispatch(createMessage(response))
         await unwrapResult(result)
          resetForm(); 
          closeModal(); 
         console.log('Form Submitted:', response);

        },
    });

    const styles = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'white',
        border: 'none',
        height: 'fit-content',
        display: 'block',
        width: '699px',
        borderRadius: '7px',
        '&:focus': {
            outline: 'none',
        },
    };

    const handleCancel = () => {
        resetForm(); 
        closeModal(); 
    };

    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styles}>
                <div className={messageStyle.basicInfo}>
                    <div className={messageStyle.notifText}>New Message</div>
                    <div onClick={closeModal}>
                        <CrossIcon />
                    </div>
                </div>

                <div style={{ margin: 20 }}>
                    <label className={messageStyle.label}>Select Admin</label>
                    <Select
                        labelId="admin-select-label"
                        id="admin-select"
                        sx={{
                            width: '100%',
                            height: '48px',
                            color: '#8D8D8D',
                            fontFamily: 'Inter',
                            lineHeight: '20px',
                            fontSize: '16px',
                            outline: 'none !important',
                            borderRadius: '16px',
                            padding: '16px',
                            fontWeight: '400',
                            border: '1px solid var(--Gray-100, #E0E2E7) !important',
                            ".MuiSelect-select": {
                                padding: '12px 1px !important',
                            },
                            ".MuiOutlinedInput-notchedOutline": {
                                border: 'none !important',
                            },
                            '.MuiInputBase-input::placeholder': {
                                color: '#8C94A3',
                                opacity: 1,
                                fontFamily: 'Figtree',
                                fontSize: '16px',
                                fontWeight: '500',
                                lineHeight: '24px',
                                textAlign: 'left',
                                height: 'auto',
                            },
                        }}
                        IconComponent={Dropdown}
                        displayEmpty
                        value={values.admin}
                        onChange={(e) => {
                            setFieldValue('admin', e.target.value);
                        }}
                    >
                        <MenuItem value="">
                            Select an Admin
                        </MenuItem>
                        {admins.map((admin) => (
                            <MenuItem key={admin._id} value={admin}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        src={admin.profileImg[0] || '/path/to/default/photo.jpg'}
                                        alt={admin.name}
                                        style={{
                                            width: '30px',
                                            height: '30px',
                                            borderRadius: '50%',
                                            marginRight: '10px',
                                        }}
                                    />
                                    {admin.name || 'Super Admin'}
                                </div>
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.admin && touched.admin && (
       <p style={{ color: 'red', fontSize: '12px' }}>{errors.admin}</p>
  )}
                </div>

                <div style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}>
                    <label className={messageStyle.label}>Message</label>
                    <div className={messageStyle.inputBox} style={{ width: '100%' }}>
                        <input
                            type="text"
                            onBlur={handleBlur}
                            value={values.name}
                            placeholder="Write your message here..."
                            name="name"
                            onChange={handleChange}
                        />
                    </div>
                    {errors.name && touched.name && (
                        <p style={{ color: 'red', fontSize: '12px' }}>{errors.name}</p>
                    )}
                </div>

                <div className={messageStyle.bottomButtons}>
                    <div onClick={handleCancel} className={messageStyle.cancelStyle}>
                        Cancel
                    </div>
                    <Button sx={{ saveCourse}} onClick={handleSubmit} variant="contained">
                        Send Message <SentIcon />
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default NewMessageModal;
